export const QuoteTagTypeOptions = ['Unfiltered', 'Default', 'Favourite'] as const;
export type QuoteTagType = (typeof QuoteTagTypeOptions)[number];
